// A milestone's completion date lives inside the MilestoneState union
// (`state.completedDate`); tolerate both the nested and flattened shapes.
export const getMilestoneCompletedDate = milestone =>
  milestone?.state?.completedDate ?? milestone?.completedDate ?? null;
